import React from "react";
import RegistrarTeamSection from "./RegistrarTeamSection";

const RegistrarTeam = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ marginTop: 0, marginBottom: 8 }}>Team of Registrar</h1>
      <p style={{ marginTop: 0, color: "#666", fontSize: 14 }}>
        Manage people shown on the public Registrar Team page (
        <code>/teamregistrar</code>).
      </p>
      <RegistrarTeamSection />
    </div>
  );
};

export default RegistrarTeam;
